module.exports = __webpack_public_path__ + "img/logo.2054d531.png";